import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LogIn02 = function LogIn02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 17c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C8.605 21 9.07 21 10 21h6.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H10c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C6 5.605 6 6.07 6 7m6 1 4 4m0 0-4 4m4-4H3"
    })
  }));
};
export default LogIn02;